import { useState } from "react";
import Input from "../../components/users/Input";
import { Button } from "../../components/ui/button";
import { usePostGenerateQrCode } from "../../query/useGenerict";
import { toast } from "sonner";
import { AxiosError } from "axios";
import QrContainer from "../../components/qr/QrContainer";

const Qr = () => {
  const [link, setLink] = useState("");
  const [qr, setQr] = useState("");
  const [isOpenQrContainer, setIsOpenQrContainer] = useState(false);

  const { mutate, isPending } = usePostGenerateQrCode();

  const handleGenerateQr = () => {
    mutate(
      { url: link },
      {
        onSuccess: (res) => {
          setIsOpenQrContainer(true);
          setQr(res);
        },
        onError: (err) => {
          if (err instanceof AxiosError) {
            if (err.response.data.message) {
              toast.error(err.response.data.message);
            } else {
              toast.error("Something went wrong");
            }
          }
        },
      }
    );
  };

  return (
    <div className="w-full px-5 pb-5 font-pro">
      <div className="max-w-lg">
        <Input
          label="Generate QR Code"
          placeholder="e.g. www.magicreview.ai"
          value={link}
          setValue={setLink}
        />
      </div>
      <Button onClick={handleGenerateQr}>Generate</Button>
      <QrContainer
        isLoading={isPending}
        qr={qr}
        openEditModal={isOpenQrContainer}
        setOpenEditModal={setIsOpenQrContainer}
      />
    </div>
  );
};

export default Qr;
